/**
 * Author:hong.rong
 * Desc:文件处理工具
 */
import mime from 'mime';
import { formatFileSize as formatSize } from './formatFileSize';

/**
 * 通用文件帮助类
 *
 * @export
 * @class FileHelper
 */
export class FileHelper {
  public static readonly formatSize = formatSize;

  /**
   * 获取文件类型
   *
   * @static getType
   * @memberof FileHelper
   * @example
   * getType('js') application/javascript
   * getType('json') application/json
   * getType('txt') text/plain
   */
  public static readonly getType = (path: string) => {
    if (typeof path !== 'string' || !path) {
      return '';
    }
    const idx = path.indexOf('?');
    if (idx < 0) {
      return mime.getType(path);
    }
    return mime.getType(path.substring(0, idx));
  };
}
